var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-nav-item-dropdown',{staticClass:"py-0 lang-switcher",attrs:{"text":`${_vm.$t('topBar_LangSwitcher')} - ${_vm.$i18n.locale}`,"right":""}},_vm._l((_vm.langs),function(lang,i){return _c('b-dropdown-item',{key:`Lang${i}`,on:{"click":function($event){return _vm.setLocale(lang.value)}}},[_vm._v(" "+_vm._s(lang.label))])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }